module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Fork-6ff9400e8bfca37574cb0874d80cc2d1.svg";